import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import products from "../data/products";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css/navigation";
import { useState, useEffect } from "react";

function Home() {
  const [expandedId, setExpandedId] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div>
      <Helmet>
        <title>G-Bond | Tyre Repair Manufacturer India</title>
      </Helmet>

      {/* HERO */}
      <div
        style={{
          backgroundImage: "url('/assets/CoverImage.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
          minHeight: isMobile ? "400px" : "500px",
        }}
      >
        {/* Overlay */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "rgba(0,0,0,0.6)",
          }}
        />

        <div
          style={{
            position: "relative",
            color: "white",
            textAlign: "center",
            padding: isMobile ? "60px 15px" : "120px 20px",
            maxWidth: "900px",
            margin: "0 auto",
          }}
        >
          <h1 style={{ fontSize: isMobile ? "22px" : "36px" }}>
            Tyre & Tube Repair Materials Manufacturer
          </h1>

          <p style={{ marginTop: "10px", fontSize: isMobile ? "14px" : "16px" }}>
            G-Bond manufactures patches, bonding gum, cushion gum and industrial rubber compounds across India.
          </p>

          <Link to="/products">
            <button style={btnStyle}>
              View Products
            </button>
          </Link>
        </div>
      </div>

      {/* STATS */}
      <div style={sectionDark}>
        <div style={flexWrapCenter}>
          {[
            ["15+", "Years Experience"],
            ["100+", "Dealers Network"],
            ["Pan India", "Supply"],
            ["High Quality", "Materials"],
          ].map((item, i) => (
            <div key={i}>
              <h2 style={{ color: "#FFC107" }}>{item[0]}</h2>
              <p>{item[1]}</p>
            </div>
          ))}
        </div>
      </div>

      {/* WHY US */}
      <div style={sectionLight}>
        <h2 style={heading}>Why Choose G-Bond?</h2>

        <div style={flexWrapCenter}>
          {["High Quality", "Industry Experience", "Bulk Supply"].map((t, i) => (
            <div key={i}>
              <h3>{t}</h3>
            </div>
          ))}
        </div>
      </div>

      {/* PRODUCTS */}
      <div style={sectionGray}>
        <h2 style={heading}>Our Products</h2>

        <Swiper
          modules={[Navigation, Autoplay]}
          navigation
          autoplay={{ delay: 3000 }}
          spaceBetween={20}
          slidesPerView={1}
          breakpoints={{
            640: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
        >
          {products.map((item) => (
            <SwiperSlide key={item.id}>
              <div style={{ padding: "10px" }}>
                <div style={card}>
                  <img
                    src={item.images[0]}
                    alt={item.name}
                    style={{ width: "100%", height: "180px", objectFit: "contain" }}
                  />

                  <h3 style={{ color: "#FFC107" }}>{item.name}</h3>

                  <p style={{ fontSize: "14px" }}>
                    {expandedId === item.id
                      ? item.description
                      : item.description.substring(0, 80) + "..."}
                  </p>

                  <button
                    onClick={() =>
                      setExpandedId(expandedId === item.id ? null : item.id)
                    }
                    style={linkBtn}
                  >
                    {expandedId === item.id ? "Show Less" : "Read More"}
                  </button>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* FEATURED */}
      <div style={sectionGray}>
        <h2 style={heading}>Featured Product</h2>

        <div
          style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            alignItems: "center",
            gap: "30px",
            maxWidth: "900px",
            margin: "auto",
          }}
        >
          <img
            src="/assets/Bonding_gum_125.png"
            alt="Bonding Gum"
            style={{ width: isMobile ? "200px" : "300px" }}
          />

          <div>
            <h3 style={{ color: "#FFC107" }}>Bonding Gum 125°C</h3>
            <p>High-performance rubber compound for tyre repair.</p>

            <a href="https://wa.me/917412885533">
              <button style={btnStyle}>Enquire Now</button>
            </a>
          </div>
        </div>
      </div>

      {/* CTA */}
      <div style={sectionDark}>
        <h2>Become a Dealer</h2>
        <p>Join our distribution network.</p>

        <a href="https://wa.me/917412885533">
          <button style={waBtn}>Contact on WhatsApp</button>
        </a>
      </div>

      {/* FOOTER */}
      <div style={footer}>
        © 2026 G Bond. All Rights Reserved.
      </div>
    </div>
  );
}

/* STYLES */
const sectionDark = {
  background: "#111",
  color: "white",
  padding: "40px 20px",
  textAlign: "center",
};

const sectionLight = {
  padding: "40px 20px",
  textAlign: "center",
};

const sectionGray = {
  background: "#2B2B2B",
  color: "white",
  padding: "40px 20px",
};

const flexWrapCenter = {
  display: "flex",
  justifyContent: "center",
  gap: "20px",
  flexWrap: "wrap",
};

const heading = {
  color: "#FFC107",
  textAlign: "center",
  marginBottom: "20px",
};

const card = {
  background: "#1C1C1C",
  padding: "15px",
  borderRadius: "10px",
  textAlign: "center",
};

const btnStyle = {
  marginTop: "15px",
  padding: "10px 20px",
  background: "#FFC107",
  border: "none",
  cursor: "pointer",
};

const waBtn = {
  marginTop: "15px",
  padding: "12px 25px",
  background: "#25D366",
  border: "none",
  color: "white",
};

const linkBtn = {
  background: "none",
  border: "none",
  color: "#FFC107",
  cursor: "pointer",
};

const footer = {
  background: "#111",
  color: "white",
  padding: "20px",
  textAlign: "center",
};

export default Home;